import React from 'react';
import ReactDOM from 'react-dom';
import App from '../src/components/app/App';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/styles.css';

ReactDOM.render(<App />, document.getElementById('root'));